module.exports = __webpack_public_path__ + "static/media/mmsys_99.29e3b46d.ico";